import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d7e037"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container scrolled" }
const _hoisted_2 = { class: "list-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Horários", -1))
const _hoisted_4 = { class: "list-header" }
const _hoisted_5 = { class: "item-data" }
const _hoisted_6 = { class: "item-operations" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_option = _resolveComponent("select-option")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, null, {
          default: _withCtx(() => [
            (_ctx.current_user.admin)
              ? (_openBlock(), _createBlock(_component_select_option, {
                  key: 0,
                  name: 'professional_id',
                  label: 'Selecione o profissional',
                  options: _ctx.professional_options,
                  empty_message: 'Cadastre um professional',
                  modelValue: _ctx.professional_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.professional_id) = $event))
                }, null, 8, ["options", "modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "btn btn-new",
          to: {
            name: 'schedule_new',
            query: { professional_id: _ctx.professional_id },
          }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Novo Horário ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("ul", {
        class: _normalizeClass({
          'list-items': true,
          loading: _ctx.isLoading,
          'empty-list': !_ctx.isLoading && !_ctx.schedules.length,
        })
      }, [
        (!_ctx.isLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((_ctx.schedules as ScheduleModel[]), (schedule) => {
              return (_openBlock(), _createElementBlock("li", {
                key: schedule.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.WeekDay[(schedule.week_day + 1) % 6]) + " das " + _toDisplayString(schedule.start_time.toClockTime()) + " até " + _toDisplayString(schedule.end_time.toClockTime()), 1),
                  _createElementVNode("p", null, _toDisplayString(schedule.specialty_description) + " - " + _toDisplayString(schedule.clinic_name), 1),
                  _createElementVNode("p", null, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fa', 'users'] }),
                    _createTextVNode(" " + _toDisplayString(schedule.max_visits), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "btn",
                    to: {
                  name: 'schedule_edit',
                  params: {
                    schedule_id: schedule.id,
                  },
                  query: { professional_id: _ctx.professional_id },
                }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: ['fa', 'pen-square'] })
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("button", {
                    class: "btn btn-delete",
                    onClick: ($event: any) => (_ctx.deleteSchedule(schedule.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fa', 'trash'] })
                  ], 8, _hoisted_7)
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}